import application_settings from '../applicationSettings';
import Event from './Event';

class getFacertData extends Event {
    eventName = 'oms_getFacertData';

    constructor() {
        super();
        this.add();
    }

    /**
     * @override
     * 
     * Event Function for Get filters
     * 
     * @param {string} data.category_id - optional - unique id for request
 
     * @return void
     *  
     */
    eventFunction(data) {
        let clientId = data.client_id;
        let categoryId = data.category_id;
        let thisObj = this;
        let requestId = (data.request_id) ? data.request_id : '';
        let action = (data.action) ? data.action : '';
        
        // request data
        data.endPoint = application_settings.endPoints.getFacertDataUrl;
        data.data = {
            client_id: clientId,
            category_id:categoryId
        };
    
        this.sendRequest(data, function (response) {
            if (response) {
                //format response data
                let data = thisObj.formatResponseData(response);

                //fire success event
                thisObj.onSuccessEvent(data, {'action' : action, 'request_id' : requestId });
            }
        });

    }
}

export default getFacertData;